<template>
  <div>
    <NavBar class="dont-show-on-print" />
    <AuthBySessionExpired class="dont-show-on-print" />

    <div class="container">
      <b-modal id="filter" no-close-on-backdrop hide-footer title="FILTRAR">
        <div class="row">
          <div class="col-md-12">
            <h6>TODOS OS USUÁRIOS?</h6>
            <div class="row">
              <b-form-radio
                @input="handleSelectUsers"
                v-model="selectAllUsers"
                :value="true"
                class="mr-2 ml-2"
                >SIM</b-form-radio
              >
              <b-form-radio
                @input="handleSelectUsers"
                v-model="selectAllUsers"
                :value="false"
                class="mr-2 ml-2"
                >NÃO</b-form-radio
              >
            </div>
            <div class="pt-0 pb-0" v-show="!selectAllUsers">
              <h6>SELECIONE OS USUARIOS:</h6>
              <b-form-checkbox-group
                v-model="user_ids"
                style="height: 200px; overflow-y: scroll"
              >
                <b-form-checkbox
                  @input="handleChangeCheckboxUser"
                  class="ml-4 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0"
                  v-for="user in users"
                  :key="user.id"
                  :value="user.id"
                >
                  {{ String(user.name).toUpperCase() }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </div>
          </div>
          <div class="col-md-12">
            <ErrorsMessages :errors="errors" />
          </div>
          <div class="col-md-12 text-right">
            <v-btn
              :disabled="loading"
              @click="paginate()"
              class="btn-filter"
              type="relief"
              ><i class="fas fa-filter mr-2 text-twenty"></i>
              {{ loading ? "CARREGANDO" : "FILTRAR" }}
            </v-btn>
          </div>
        </div>
      </b-modal>

      <div class="row">
        <div
          class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0 dont-show-on-print"
        >
          <v-btn class="btn-return mb-3" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
          <h3 class="title-pages pt-1">RELATÓRIO: HISTÓRICO IMPRIMIR</h3>
        </div>
        <div
          class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right dont-show-on-print"
        >
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
          <v-btn
            :disabled="data.length == 0"
            @click="handleToPrint"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
      </div>

      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-5 text-center" v-show="data.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>

        <v-data-table
          v-show="data.length > 0"
          dense
          :headers="[
            { text: 'Sobre', value: 'about', sortable: false },
            { text: 'Quem / Quando', value: 'text', sortable: false },
          ]"
          :items="data"
          :footer-props="{
            'items-per-page-options': [100, 200, 500, 1000],
            'items-per-page-text': 'Mostrar',
          }"
          :options.sync="options"
          :server-items-length="total"
          class="modern-table"
          :no-data-text="'Nenhum medicamento encontrado'"
          :loading-text="'Carregando medicamentos...'"
        >
          <template v-slot:[`item.about`]="{ item }">
            {{ item.about }}
          </template>
          <template v-slot:[`item.text`]="{ item }">
            {{ item.text }}
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") }}
          </template>
        </v-data-table>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import routes from "../../routes";

import { formatDate } from "../../lib/format";

import AuthBySessionExpired from "../Components/AuthBySessionExpired";

import ErrorsMessages from "../Components/ErrorsMessages";

import NavBar from "../NavBar";

import { restore, save } from "../../lib/functions";

import moment from "moment";

export default {
  name: "ReportsPrintLog",
  components: {
    NavBar,
    ErrorsMessages,
    AuthBySessionExpired,
  },
  data() {
    return {
      user_ids: [],

      selectAllUsers: true,

      user_id: "ALL",

      users: [],

      total: 0,
      options: {},
      data: [],
      errors: [],

      loading: false,
      interactCheckBoxUsers: false,
    };
  },

  created() {
    this.retrieve();
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },

  methods: {
    moment,
    formatDate,

    saveState() {
      save(this, "ReportsPrintLog", ["user_id"]);
    },

    handleChangeCheckboxUser(e) {
      if (e.length > 0) {
        if (this.user_ids.length != this.users.length) {
          this.interactCheckBoxUsers = true;
        } else {
          this.interactCheckBoxUsers = false;
        }
        if (this.user_ids.length != this.users.length) {
          this.selectAllUsers = false;
        } else {
          this.selectAllUsers = true;
        }
      } else {
        this.interactCheckBoxUsers = false;
      }
    },

    handleSelectUsers(e) {
      if (e) {
        this.user_ids = this.users.map(({ id }) => id);
      } else {
        if (!this.interactCheckBoxUsers) {
          this.user_ids = [];
        }
      }
    },

    async retrieve() {
      restore(this, "ReportsPrintLog");

      if (this.errors.length == 0) await this.getUsers();
      if (this.resident_id && this.errors.length == 0) await this.paginate();

      let { modal } = this.$router.currentRoute.query;

      if (modal) {
        this.$bvModal.show("filter");
      }
    },

    async getUsers() {
      try {
        const response = await api.get("/rest-home/user/all");

        const { error, errors, users } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.users = users;
          this.user_ids = users.map(({ id }) => id);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async paginate() {
      try {
        this.loading = true;

        const { page, itemsPerPage } = this.options;

        const { user_ids } = this;

        var params = {
          user_ids,
          page,
          itemsPerPage,
        };

        const response = await api.get("/rest-home/report/print-log", {
          params,
        });

        const { data, error, errors, total } = response.data;

        if (error) {
          this.data = [];
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.total = total;
          this.$bvModal.hide("filter");
        }

        this.saveState();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleToPrint() {
      window.print();
    },

    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
@media print {
  .dont-show-on-print {
    display: none;
  }
}
</style>
